const [domain, extension] = window.location.hostname.split(".").splice(-2);
const domainPrefix = extension ? "." : "";
const domainSuffix = extension ? `.${extension}` : "";

const COOKIE_PREFIX = process.env.LINK_ENV === "production" ? "" : `${process.env.LINK_ENV}-`;
export const COOKIE_DOMAIN = `${domainPrefix}${domain}${domainSuffix}`;
export const COOKIE_AUTH_VIEW_AS_USER = `${COOKIE_PREFIX}authViewAsUser`;
